import { useState, useMemo } from "react";

const Table2 = ({ data }) => {
  const [area, setArea] = useState("");
  const [date, setDate] = useState("");
  const [accountNumber, setaccountNumber] = useState("");

  // Extract unique area names for dropdown
  const areaOptions = useMemo(() => {
    const areas = data
      .map((item) => item.areaName)
      .filter((val, idx, arr) => val && arr.indexOf(val) === idx);
    return areas;
  }, [data]);

  // Filter logic
  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const matchesArea = area ? item.areaName === area : true;
      const matchesDate = date
        ? new Date(item.createdAt).toISOString().slice(0, 10) === date
        : true;
      const matchesAccount = accountNumber
        ? item.accountNumber.toLowerCase().includes(accountNumber.toLowerCase())
        : true;

      return matchesArea && matchesDate && matchesAccount;
    });
  }, [data, area, date, accountNumber]);

  return (
    <div className="p-4 bg-white shadow-lg rounded-xl  max-h-[50vh] overflow-auto">
      {/* Filters */}
      <div className="flex flex-wrap items-center gap-4 mb-4">
        {/* Area Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Area
          </label>
          <select
            value={area}
            onChange={(e) => setArea(e.target.value)}
            className="border rounded-lg px-3 py-2 w-48 focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Areas</option>
            {areaOptions.map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>
        </div>

        {/* Date Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date
          </label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="border rounded-lg px-3 py-2 w-48 focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Account No Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Account No
          </label>
          <input
            type="text"
            placeholder="Search by Account No"
            value={accountNumber}
            onChange={(e) => setaccountNumber(e.target.value)}
            className="border rounded-lg px-3 py-2 w-64 focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse border border-gray-200">
          <thead className="bg-blue-100 text-gray-800">
            <tr>
              <th className="px-4 py-2 border border-gray-200 text-left">Nama</th>
              <th className="px-4 py-2 border border-gray-200 text-left">Kawasan</th>
              <th className="px-4 py-2 border border-gray-200 text-left">Account No</th>
              <th className="px-4 py-2 border border-gray-200 text-left">Phone</th>
              <th className="px-4 py-2 border border-gray-200 text-left">Email</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item) => (
                <tr
                  key={item.id}
                  className="hover:bg-blue-50 transition-colors"
                >
                  <td className="px-4 py-2 border border-gray-200">{item.name || "-"}</td> 
                  <td className="px-4 py-2 border border-gray-200">{item.areaId || "-"}</td>
                  <td className="px-4 py-2 border border-gray-200">{item.accountNumber || "-"}</td>
                  <td className="px-4 py-2 border border-gray-200">{item.phone || "-"}</td>
                  <td className="px-4 py-2 border border-gray-200">{item.email || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="5"
                  className="text-center py-4 text-gray-500 border border-gray-200"
                >
                  No matching records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table2;
